var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5C13.6838 0.5 14.2817 0.749453 14.7666 1.23438C15.2514 1.71918 15.5007 2.31674 15.5 3V19.7578L14.8027 19.46L8 16.5439L1.19727 19.46L0.5 19.7578V3C0.5 2.31633 0.74937 1.7187 1.23438 1.23438C1.71901 0.750566 2.31636 0.500918 2.99902 0.5H13Z",
    fill: "#62C7AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectionActive);
export default __webpack_public_path__ + "static/media/selection-active.6b546315695d773610689eca1d13ee00.svg";
export { ForwardRef as ReactComponent };